import { createSelector } from 'reselect';

const makeGetStudents = () => {
  return createSelector(
    state => state.entities.student,
    state => state.list.students,
    state => state.students.pageStart,
    state => state.students.pageLength,
    state => state.totalStudents,
    (students, list, pageStart, pageLength, totalStudents) => {
      return list.slice(pageStart, pageStart + pageLength).map(studentId => {
        return students[studentId];
      });
    }
  );
};

export const getStudents = makeGetStudents();

const makeGetInvitations = () => {
  return createSelector(
    state => state.entities.invitation,
    state => state.list.invitations,
    state => state.invitations.pageStart,
    state => state.invitations.pageLength,
    state => state.totalInvitations,
    (invitations, list, pageStart, pageLength) => {
      return list.slice(pageStart, pageStart + pageLength).map(invitationId => {
        return invitations[invitationId];
      });
    }
  );
};

export const getInvitations = makeGetInvitations();



// WEBPACK FOOTER //
// ./src/js/selectors/courseDetail.js